export default __webpack_public_path__ + "static/media/separate-settings.44a5fc10.svg";